import { AxiosRequestConfig } from 'axios';

export async function withRetry(
  instance: any,
  url: string,
  config: AxiosRequestConfig,
  retryDelay: number = 3000,
  retryStatus: number = 202
) {
  let play = true;

  while (play) {
    const response = await instance(url, config);

    if (response.status !== retryStatus) {
      play = false;
      return response;
    }

    await delay(retryDelay);
  }

  return Promise.reject('');
}

function delay(milisec: number) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve('resolved');
    }, milisec);
  });
}
